import api from "src/apis/api";

// ── Fetch ────────────────────────────────────────────────────────────────────
export async function fetchBuyerRequirements({
  page = 1,
  per_page = 20,
  status = "",
  city = "",
  q = "",
} = {}) {
  const params = new URLSearchParams();
  params.set("page", page);
  params.set("per_page", per_page);
  if (status) params.set("status", status);
  if (city) params.set("city", city);
  if (q) params.set("q", q);

  const { data } = await api.get(`/api/v1/buyer_requirements?${params}`);
  return data;
}

// ── Create ───────────────────────────────────────────────────────────────────
export async function createBuyerRequirement(payload) {
  const { data } = await api.post("/api/v1/buyer_requirements", {
    buyer_requirement: payload,
  });
  return data;
}

// ── Update ───────────────────────────────────────────────────────────────────
export async function updateBuyerRequirement(id, payload) {
  const { data } = await api.patch(`/api/v1/buyer_requirements/${id}`, {
    buyer_requirement: payload,
  });
  return data;
}

// ── Delete ───────────────────────────────────────────────────────────────────
export async function deleteBuyerRequirement(id) {
  const { data } = await api.delete(`/api/v1/buyer_requirements/${id}`);
  return data;
}
